export const MODAL_WIDTH = {
  Default: 800,
  'X-Small': 400,
  Small: 600,
  Dense: 400,
  Medium: 800,
  Large: 1000,
  'X-Large': 1000,
}
